import { warning } from '@valid-eval/shared-react-components';
import { Middleware } from 'redux';

import { logoutSuccess } from '../../data/actions/users';

type BasicAction = {
  type: string;
  payload?: any;
};

const isApiError = (action: BasicAction) => action.payload && action.payload.name === 'ApiError';

export const handleApiErrors: Middleware = (store) => (next) => (action: any) => {
  if (!isApiError(action)) return next(action);

  if (action.payload.status === 401) {
    store.dispatch(logoutSuccess());
    if (action.type !== 'users/LOAD_RESULT' && action.type !== 'users/LOGIN_RESULT')
      warning('Your session has expired, please login again');
  }

  return next(action); // Allow the failed action to move on, so reducers can change state accordingly
};
